import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { confirm, appliesTo, approvalScope, toggleDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import Delayed from 'react-delayed';
import moment from 'moment';

// Components
import Drawer from '../Drawer/Drawer';
import LoadMore from '../Common/LoadMore';
import Toolbar from '../Common/Toolbar';

const ProctorApprovals = observer(class ProctorApprovals extends React.Component {
  constructor() {
    super();
    this.getInstallApprovals = this.getInstallApprovals.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.deleteApprovals = this.deleteApprovals.bind(this);
    this.showDetails = this.showDetails.bind(this);
  }

  componentWillMount() {
    const { SessionStore } = this.props.store;

    this.getInstallApprovals();

    this.state = {
      drawerOpen: false,
      drawerContent: null,
      proctorAccountSid: null,
      selectedRows: []
    }

    // Make sure proctor types are in store
    SessionStore.getProctorTypes();
  }

  componentDidMount() {
    const proctorAccountSid = this.props.routing.location.query.proctor;

    if(proctorAccountSid) {
      this.showDetails(proctorAccountSid);
    }
  }

  getInstallApprovals(query) {
    // Clear out any previously returned approvals
    this.props.store.AdminStore.approvals = [];

    // Set the query object
    let standardQuery = {
      status: ['allow', 'deny'],
      limit: 25
    }

    const fullQuery = Object.assign(standardQuery, query);

    this.props.store.AdminStore.approvalFilterObj = fullQuery;

    // Perform the API call
    this.props.store.AdminStore.getInstallApprovals();
  }

  applyFilters(e) {
    if(e) {
      e.preventDefault();
    }

    let query = {};

    // Get the status and keyword filter values
    const status = this.status.value || '';
    const keyword = this.keyword.value || '';

    if(status) {
      query.status = status;
    }

    if(keyword) {
      query.titleFilter = `*${keyword}*`;
    }

    // Get the scope filter value and apply it to the right property
    switch (this.scope.value) {
      case 'install':
        query.applicationInstallSid = 'AI*'
        break;

      case 'instructor':
        query.instructorUserSid = 'US*'
        break;

      case 'course':
        query.courseSid = 'CU*'
        break;

      case 'exam':
        query.examSid = 'EX*'
        break;

      case 'student':
        query.studentUserSid = 'US*'
        break;

      case 'enrollment':
        query.enrollmentSid = 'EN*'
        break;

      case 'session':
        query.examSessionSid = 'ES*'
        break;

      default:
        break;
    }

    this.getInstallApprovals(query);
  }

  resetFilters() {
    this.getInstallApprovals();
  }

  handleSelect(e, sid) {
    let selectedRows = [...this.state.selectedRows];
    let rowIndex = -1;

    if(e.target.checked) {
      selectedRows.push(sid);
    } else {
      rowIndex = selectedRows.indexOf(sid);
      selectedRows.splice(rowIndex, 1);
    }

    this.setState({
      selectedRows
    });
  }

  deleteApprovals() {
    const { translation } = this.props;
    const { ProctorStore, ReportStore } = this.props.store;

    let msg = {
      heading: translation.delete_confirm.heading_singular,
      body: translation.delete_confirm.body_singular,
      button: translation.delete_confirm.button
    }

    if(this.state.selectedRows.length > 1) {
      msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
      msg.body = translation.delete_confirm.body_plural;
    }


    // Loop through all the selected funding rules and send delete API request
    const _this = this;

    confirm(
      msg,
      () => {
        for(let i = 0; i < _this.state.selectedRows.length; i++) {
          let callback = null;

          if(i === _this.state.selectedRows.length - 1) {
            callback = ReportStore.getReportData('approvals');
          }

          ProctorStore.deleteProctorApproval(
            _this.state.selectedRows[i],
            callback
          );
        }

        _this.setState({
          selectedRows: []
        });
      }
    );
  }

  showDetails(proctorAccountSid) {
    const _this = this;
    const { SessionStore } = this.props.store;

    this.setState({
      proctorAccountSid
    }, function(){
      SessionStore.loading = false;
      toggleDrawer(null, this, 'ProctorDetails');
    });
  }

  editApproval(e, approval) {
    const _this = this;
    const { ProctorStore, SessionStore } = this.props.store;
    const applyTo = appliesTo(approval);
    const status = e.target.value;

    const data = {
      reviewedByUserSid: SessionStore.profile.sid,
      status,
      applyTo
    }

    const callback = () => {
      approval.status = status;
      _this[`checkbox-${approval.sid}`].checked = false;
    }

    ProctorStore.updatePendingApprovals(approval.sid, data, callback, true);
  }

  renderResults(approvals) {
    const { translation } = this.props;
    const { ReportStore, SessionStore } = this.props.store;
    const { appendReportData, reportFormat, reportNext } = ReportStore;
    const { userTimezone } = SessionStore;

    let group = null;
    let concat = false;

    return (
      <div className="table-scrollable">
        <div className="table-wrap">
          <table className="report-table">
            <thead>
              <tr>
                <th id="heading-select" scope="col">
                  <span className="meta">Select</span>
                </th>
                <th id="heading-name" className="subtitle" scope="col">
                  {translation.proctor}

                  <div
                    className={`th-fixed`}
                    aria-hidden="true"
                  >
                    {translation.proctor}
                  </div>
                </th>
                <th id="heading-status" className="subtitle" scope="col">
                  {translation.status}

                  <div
                    className={`th-fixed`}
                    aria-hidden="true"
                  >
                    {translation.status}
                  </div>
                </th>
                <th id="heading-date" className="subtitle" scope="col">
                  {translation.date}

                  <div
                    className={`th-fixed`}
                    aria-hidden="true"
                  >
                    {translation.date}
                  </div>
                </th>
                <th id="heading-applies" className="subtitle" scope="col">
                  {translation.applies_to}

                  <div
                    className={`th-fixed`}
                    aria-hidden="true"
                  >
                    {translation.applies_to}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {approvals.map(
                (approval, i) =>
                <tr key={i}>
                  <td className="check-col" aria-labelledby="heading-select">
                    <div>
                      <input
                        id={`select-${approval.sid}`}
                        className="checkbox-input"
                        type="checkbox"
                        onChange={(e) => this.handleSelect(e, approval.sid)}
                      />

                      <label
                        className="checkbox-label checkbox-label--solo" htmlFor={`select-${approval.sid}`}
                      >
                        <span className="meta">Select {approval.sid}</span>
                      </label>
                    </div>
                  </td>
                  <td aria-labelledby="heading-name">
                    <button
                      className="btn--link"
                      onClick={(e) => this.showDetails(approval.proctorAccount.sid)}
                    >
                      {approval.proctorAccount.accountName &&
                        approval.proctorAccount.accountName
                      }

                      {!approval.proctorAccount.accountName &&
                        `${approval.proctorAccount.firstName} ${approval.proctorAccount.lastName}`
                      }
                    </button>
                  </td>
                  <td
                    aria-labelledby="heading-status"
                    className={`capitalize ${approval.status === 'allow' ? 'positive' : 'negative'}`}
                  >
                    {approval.status}

                    {(approval.status === 'allow' || approval.status === 'deny') &&
                      <label className="lbl--edit" htmlFor={`edit-approval-${approval.sid}`}>
                        (edit)
                      </label>
                    }

                    {(approval.status === 'allow' || approval.status === 'deny') &&
                      <input
                        id={`edit-approval-${approval.sid}`}
                        type="checkbox"
                        ref={(input) => this[`checkbox-${approval.sid}`] = input}
                      />
                    }

                    {(approval.status === 'allow' || approval.status === 'deny') &&
                      <label className="select">
                        <select
                          defaultValue={approval.status}
                          onChange={(e) => this.editApproval(e, approval)}
                        >
                          <option value="allow">Approve</option>
                          <option value="deny">Deny</option>
                        </select>
                      </label>
                    }
                  </td>
                  <td aria-labelledby="heading-date">
                    {approval.dateReviewed &&
                      moment(approval.dateReviewed)
                        .tz(userTimezone)
                        .format('M/D/YYYY [at] h:mma z')
                    }
                  </td>
                  <td aria-labelledby="heading-applies" className="body">
                    {approvalScope(approval, translation)}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {reportNext &&
            <LoadMore
              url={reportNext}
              text="Load more results"
              dataFormat={reportFormat}
              dataSet={appendReportData}
              concat={concat}
              group={group}
              wrapper={'.table-wrap'}
              {...this.props}
            />
          }
        </div>
      </div>
    )
  }

  render() {
    const { reportData, translation } = this.props;
    const { SessionStore } = this.props.store;

    return (
      <div>
        {!reportData.length && !SessionStore.loading &&
          <span className="no-results">{translation.no_results}</span>
        }

        {reportData.length > 0 &&
          this.renderResults(reportData)
        }

        <Delayed
          mounted={this.state.selectedRows.length > 0}
          unmountAfter={250}
        >
          <Toolbar
            selectedRows={this.state.selectedRows}
            deleteText={translation.delete}
            deleteFunction={this.deleteApprovals}
            {...this.props}
          />
        </Delayed>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          {...this.props}
          proctorAccountSid={this.state.proctorAccountSid}
          callback={() => this.setState({drawerContent: null, drawerOpen: false, proctorAccountSid: null})}
        />
      </div>
    )
  }
})

export default translate('ProctorApprovals')(ProctorApprovals);



// WEBPACK FOOTER //
// ./src/app/components/Reports/ProctorApprovals.js